module.exports = __webpack_public_path__ + "713d1ba0d580cc0a33a424eab1e72779.svg";